module.exports = __webpack_public_path__ + "static/img/company-building.d85edf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/company-building.jpg
// module id = crZ0
// module chunks = 5